import type { FormGroup, FormInput } from "~/types/storyblok/storyblok";

export const assignFieldValue = (
	component: string,
	items?: FormGroup[] | FormInput[]
) => {
	if (component === "form-input") {
		return null;
	} else if (component === "checkbox-group") {
		return [];
	} else if (
		(component === "form-group" || component === "form-product") &&
		items
	) {
		const template = (items as FormGroup[]).reduce(
			(acc: Record<string, unknown>, item) => {
				if (item.name) {
					acc[item.name] = assignFieldValue(item.component, item.items);
				}
				return acc;
			},
			{}
		);

		return component === "form-product" ? [template] : template;
	}

	return null;
};
